module.exports = __webpack_public_path__ + "img/eatin-takeout.6ac97511.png";